import { render, staticRenderFns } from "./finuslugi-estates-item.vue?vue&type=template&id=7d7ea9ba&scoped=true"
import script from "./finuslugi-estates-item.vue?vue&type=script&lang=js"
export * from "./finuslugi-estates-item.vue?vue&type=script&lang=js"
import style0 from "./finuslugi-estates-item.vue?vue&type=style&index=0&id=7d7ea9ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7ea9ba",
  null
  
)

export default component.exports